<div fxLayout="row">
  <div fxLayout="column">
    <table role="presentation" *ngIf="data && (!hasSections)">
      <tr *ngFor="let item of data?.data">
          <td class="field-label">{{item?.name}}</td>
          <td class="fieldValue">{{item?.value}}</td>
      </tr>
    </table>
    <div *ngIf="data && hasSections">
      <table role="presentation" *ngFor="let section of data?.data">
        <tr><td class="field-label section-label">{{section?.section.name}}</td></tr>
        <tr *ngFor="let item of section?.section.fields">
            <td class="field-label">{{item?.name}}</td>
            <td class="fieldValue">{{item?.value}}</td>
        </tr>
      </table>
    </div>
  </div>
</div>
